import { render, staticRenderFns } from "./Odr.vue?vue&type=template&id=46737cbe&scoped=true"
import script from "./Odr.vue?vue&type=script&lang=js"
export * from "./Odr.vue?vue&type=script&lang=js"
import style0 from "./Odr.vue?vue&type=style&index=0&id=46737cbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46737cbe",
  null
  
)

export default component.exports